import React from 'react';
import RouteConfig from './router';
import './asstes/css/index.scss';
import ZhTitleComponent from "./components/ZhTitleComponent/ZhTitleComponent";
import {
	getUrlParams,
	setStorageCache,
	getStorageCache,
	stringBoolean,
	isIOS,
	isAndroid,
	isInBocApp,
	compareVersion,
	setSessionCache,
	isInWeChat, getSessionCache
} from "./asstes/js/Utils";
import listenEvent from "./asstes/js/events";
import Analysis from "./asstes/js/Analysis";
import Login from "./components/Login/Login";
import history from "./router/history";
import Config from "./asstes/js/Config";
import {historyOfPush} from "./asstes/js/IntegratedProcessing";
import LoadingComponent from "./components/LoadingComponent/LoadingComponent";
import flexible from "./asstes/js/flexible";
import {checkShareTime} from "./asstes/js/Rescource";

class App extends React.Component {
	state = {
		loading: {
			text: '',
			show: false
		},
		title: '',
		login: {
			loading: true, // 登录过程
			show: false
		}
	}

	UNSAFE_componentWillMount() {
		const userInfo = getStorageCache(`userInfo${Config.channelId}`)
		Config.loginInfo = userInfo ? JSON.parse(userInfo) : null
		Config['loginInfo'] = userInfo ? JSON.parse(userInfo) : null
		listenEvent.on('showLoading', this.showLoading);
		listenEvent.on('hideLoading', this.hideLoading);
		listenEvent.on('toggleLogin', this.toggleLogin);
		//=== 微信授权逻辑start
		const pathName = history.location.pathname
		const historyHash = history.location.search
		const historySearch = window.location.search
		const storageBocOpenId = getStorageCache('bocOpenId') // 缓存下的中行的openId
		// const storageBocOpenId = '' // 缓存下的中行的openId
		// const storageFzsOpenId = getStorageCache('fzsOpenId') // 缓存下的FZS的openId
		const storageFzsOpenId = '' // 缓存下的FZS的openId
		const timeStamp = getUrlParams(historyHash, 'timestamp') || 0
		if (getStorageCache('shareOpenId')) { // 获取到分享人的openid
			Config.shareOpenId = getStorageCache('shareOpenId')
			Config['shareOpenId'] = getStorageCache('shareOpenId')
		}
		if (getStorageCache('shareUserId')) { // 获取到分享人的UserId
			Config.shareUserId = getStorageCache('shareUserId')
			Config['shareUserId'] = getStorageCache('shareUserId')
		}
		// 判断是否存在分享ID 有先存起来
		if (getUrlParams(historySearch, 'shareOpenId') || getUrlParams(historySearch, 'shareUserId')) {
			let shareOpenId = getUrlParams(historySearch, 'shareOpenId') || ''
			let shareUserId = getUrlParams(historySearch, 'shareUserId') || ''
			setStorageCache('shareOpenId', shareOpenId)
			setStorageCache('shareUserId', shareUserId)
			Config.shareOpenId = shareOpenId
			Config.shareUserId = shareUserId
			Config['shareOpenId'] = shareOpenId
			Config['shareUserId'] = shareUserId
		}
		if (storageBocOpenId) {
			Config.bocOpenId = storageBocOpenId
			Config['bocOpenId'] = storageBocOpenId
		} else {
			// 全局判断是否是微信授权后返回的 是的话立刻跳转
			let urlLInk = getUrlParams(historyHash, 'link')
				|| getUrlParams(historySearch, 'link') // 当前url上面的需要跳转的链接名
			let bocOpenid = getUrlParams(historyHash, 'openid')
				|| getUrlParams(historySearch, 'openid') // 中行openId
			if ((urlLInk === 'index' || urlLInk === 'reward') && bocOpenid) {
				(pathName !== '/reward' && urlLInk !== 'index') && (history.push('/reward?notLink=true'));
				Config.bocOpenId = bocOpenid
				Config['bocOpenId'] = bocOpenid
				setStorageCache('bocOpenId', bocOpenid)
			}
		}
		if (storageFzsOpenId) {
			Config.fzsOpenId = storageFzsOpenId
			Config['fzsOpenId'] = storageFzsOpenId
		} else {
			let fzsString = getUrlParams(historyHash, 'fzs') // 判断当前URL是否是蜂助手授权
			let fzsOpenId = getUrlParams(historyHash, 'openId') // 蜂助手openId
			const isTimeIN = (new Date().getTime() - timeStamp) < 30000 // 在30S内进入才正常
			if (!isTimeIN) {
				let timePageCount = getSessionCache('timePageCount') || 0
				if (parseInt(timePageCount) > 3 && fzsString && stringBoolean(fzsString) && fzsOpenId) {
					Config.fzsOpenId = fzsOpenId
					Config['fzsOpenId'] = fzsOpenId
					Config.goFzsAuthorize = true
				} else if (isInWeChat()) {
					setSessionCache('timePageCount', timePageCount + 1)
					Config.goFzsAuthorize = false
				}
			} else if (fzsString && stringBoolean(fzsString) && fzsOpenId && isTimeIN) {
				Config.fzsOpenId = fzsOpenId
				Config['fzsOpenId'] = fzsOpenId
				// setStorageCache('fzsOpenId', fzsOpenId)
				setSessionCache('timePageCount', 0)
				Config.goFzsAuthorize = true
			}
		}
		//=== 微信授权逻辑end
		isInBocApp() && this.initZH();
		let instance = Analysis.getCnzzAnalysisInstance('1261631388');
		window.$analysis = instance
		window.onoffline = () => {
			setSessionCache('prevPage', window.location.href)
			historyOfPush('/network')
		}
		// history.listen(() => {
		// 	let dom = document.querySelector('.tips-container')
		// 	if (dom) {
		// 		dom.remove()
		// 	}
		// })
		setTimeout(() => {console.log(Config)}, 0);
		if ((Config.shareUserId && Config.shareUserId !== 'null') && Config.fzsOpenId && Config.bocOpenId) { // 登记分享次数
			checkShareTime()
		}
		this.toggleLogin('hide', 'loginSuccess')
	}

	componentWillUnmount() {
		listenEvent.off('toggleLogin', this.toggleLogin)
	}

	showLoading = (text) => {
		this.setState({
			loading: {
				text: text || '',
				show: true
			}
		})
	}

	hideLoading = () => {
		this.setState({
			loading: {
				text: '',
				show: false
			}
		})
	}

	toggleLogin = (type, result) => {
		if (type === 'show') {
			this.setState({
				login: {
					loading: false,
					show: true
				}
			})
		} else if (type === 'hide') {
			this.setState({
				login: {
					loading: result && result === 'loginSuccess',
					show: false
				}
			}, () => {
				if (result && result === 'loginSuccess') {
					setTimeout(() => {
						this.setState({
							login: {
								loading: false,
								show: false
							}
						})
						isInWeChat() && flexible.weChatLoad(true)
					}, 200)
				}
			})
		}
	}

	initZH() {
		let script = document.createElement('script')
		let pth = "https://ebsnew.boc.cn/bocphone/BocMerchant/" // 生产环境
		if (isIOS()) {
			script.src = pth + 'paylib/ios.js'
			document.getElementsByTagName('head')[0].appendChild(script)
		} else if (isAndroid()) {
			script.src = pth + 'paylib/android.js'
			document.getElementsByTagName('head')[0].appendChild(script)
		} else {
			console.log('无法识别终端类型')
		}
	}

	render() {
		let {login, title, loading} = this.state
		let appVersion = '3.0.0'
		if (isInBocApp()) {
			appVersion = ((window.navigator.userAgent.includes('bocapp')) && (window.navigator.userAgent).match(/bocapp\(\S+\)/)[0].slice(7, -1)) || '3.0.0'
		}

		return (
			<>
				{/* loading模块 */}
				{loading.show ? <LoadingComponent text={loading.text}/> : null}
				{
					isInBocApp() && !(compareVersion(appVersion, '6.3.0') > -1) ? <ZhTitleComponent title={title}/> : null
				}
				{
					!login.loading ?
						<RouteConfig.RouterConfig/> : null
				}
				{
					login.show ? <Login/> : null
				}
			</>
		)
	}
}

export default App;
